import React from "react";
import { Shimmer } from "..";

const ChatBox2: React.FC = () => {
  return (
    <>
      <div className="relative flex w-full my-2 justify-start overflow-hidden">
        <p className="bg-gray-200 p-3 px-10  relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
          <br />
          <span className="block mt-[5px] text-[9.9px] opacity-50"></span>
        </p>
        <Shimmer />
      </div>
      <div className="relative flex w-full my-2 justify-start overflow-hidden">
        <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
          <br />
          <span className="block mt-[5px] text-[9.9px] opacity-50"></span>
        </p>
        <Shimmer />
      </div>
      <div className="relative flex w-full my-2 justify-end overflow-hidden">
        <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
          <br />
          <span className="block mt-[5px] text-[9.9px] opacity-50"></span>
        </p>
        <Shimmer />
      </div>
      <div className="relative flex w-full my-2 justify-end overflow-hidden">
        <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
          <br />
          <span className="block mt-[5px] text-[9.9px] opacity-50"></span>
        </p>
        <Shimmer />
      </div>
      {/*<div className="relative flex w-full my-2 justify-start" >
      <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
        {"lorem ipsum..."}
      
        <br />
        <span className="block mt-[5px] text-[9.9px] opacity-50">12:15</span>
      </p>
    </div> <div className="relative flex w-full my-2 justify-start" >
      <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
        {"lorem ipsum..."}
      
        <br />
        <span className="block mt-[5px] text-[9.9px] opacity-50">12:15</span>
      </p>
    </div> <div className="relative flex w-full my-2 justify-start" >
      <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
        {"lorem ipsum..."}
      
        <br />
        <span className="block mt-[5px] text-[9.9px] opacity-50">12:15</span>
      </p>
    </div> <div className="relative flex w-full my-2 justify-start" >
      <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
        {"lorem ipsum..."}
      
        <br />
        <span className="block mt-[5px] text-[9.9px] opacity-50">12:15</span>
      </p>
    </div> <div className="relative flex w-full my-2 justify-start" >
      <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
        {"lorem ipsum..."}
      
        <br />
        <span className="block mt-[5px] text-[9.9px] opacity-50">12:15</span>
      </p>
    </div> <div className="relative flex w-full my-2 justify-start" >
      <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
        {"lorem ipsum..."}
      
        <br />
        <span className="block mt-[5px] text-[9.9px] opacity-50">12:15</span>
      </p>
  </div>**/}
      <div className="relative flex w-full my-2 justify-start overflow-hidden">
        <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
          <br />
          <span className="block mt-[5px] text-[9.9px] opacity-50"></span>
        </p>
        <Shimmer />
      </div>
      <div className="relative flex w-full my-2 justify-start overflow-hidden">
        <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
          <br />
          <span className="block mt-[5px] text-[9.9px] opacity-50"></span>
        </p>
        <Shimmer />
      </div>{" "}
      {/* <div className="relative flex w-full my-2 justify-start">
        <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
          {"lorem ipsum..."}

          <br />
          <span className="block mt-[5px] text-[9.9px] opacity-50">12:15</span>
        </p>
      </div>{" "}
      <div className="relative flex w-full my-2 justify-start">
        <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
          {"lorem ipsum..."}

          <br />
          <span className="block mt-[5px] text-[9.9px] opacity-50">12:15</span>
        </p>
      </div>{" "}
      <div className="relative flex w-full my-2 justify-start">
        <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
          {"lorem ipsum..."}

          <br />
          <span className="block mt-[5px] text-[9.9px] opacity-50">12:15</span>
        </p>
      </div>{" "}
      <div className="relative flex w-full my-2 justify-start">
        <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
          {"lorem ipsum..."}

          <br />
          <span className="block mt-[5px] text-[9.9px] opacity-50">12:15</span>
        </p>
      </div>{" "}
      <div className="relative flex w-full my-2 justify-start">
        <p className="bg-gray-200 p-3 px-10 relative right-0 text-left max-w-[65%] rounded-xl text-sm text-[#000000E4] font-SegoeUI font-normal before:content-[''] before:absolute before:top-0 before:left-[-12px] before:w-5 before:h-5 chatBuble2">
          {"lorem ipsum..."}

          <br />
          <span className="block mt-[5px] text-[9.9px] opacity-50">12:15</span>
        </p>
      </div> */}
    </>
  );
};

export default ChatBox2;
